import React from 'react';
import { HeroSection } from './components/HeroSection';
import { BenefitsSection } from './components/BenefitsSection';
import { TrustGuarantees } from './components/TrustGuarantees';
import { PricingSection } from './components/PricingSection';
import { ReviewCarousel } from './components/ReviewCarousel';
import { StorySection } from './components/StorySection';
import { FaqSection } from './components/FaqSection';
import { FinalCta } from './components/FinalCta';
import { UrgencyBanner } from './components/UrgencyBanner';
import { SpecsSection } from './components/SpecsSection';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  return <div className="min-h-screen bg-brand-dark font-sans selection:bg-brand-orange/30" data-id="element-0">
      {/* Main Container - Mobile optimized, max width for larger screens */}
      <main className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 w-full overflow-x-hidden" data-id="element-1">
        <HeroSection data-id="element-2" />
        <BenefitsSection data-id="element-3" />
        <TrustGuarantees data-id="element-4" />
        <PricingSection data-id="element-5" />
        <ReviewCarousel data-id="element-6" />
        <StorySection data-id="element-7" />
        <FaqSection data-id="element-8" />
        <FinalCta data-id="element-9" />
        <UrgencyBanner data-id="element-10" />
        <SpecsSection data-id="element-11" />
        <Footer data-id="element-12" />
      </main>
      <RecentPurchaseToast data-id="element-13" />
    </div>;
}